
export const getCountryCodeByTitle = function( title:any) {
        let countryCode = 9907; // canada
        switch (title.toLowerCase()) {
            case 'united stated':
            case 'us':
            case 'usa':
                countryCode = 9906;
                break;

            case 'canada':
                countryCode = 9907;
                break;

            case 'australia':
                countryCode = 9905;
                break;

            case 'united kingdom':
                countryCode = 9904;
                break;

            case 'new zealand':
                countryCode = 9903;
                break;

            case 'Brasil':
            case 'Brazil':
                countryCode = 9902;
                break;

            default:
                countryCode = 9907;
        }
        return countryCode;
}

export const getStateCodeByTitle = function( title:any) {
    let stateCode = 9886; // British Columbia
    switch (title.toLowerCase()) {
        case 'british columbia':
        case 'bc':
            stateCode = 9886;
            break;

        case 'alberta':
        case 'ab':
            stateCode = 9885;
            break;

        case 'ontario':
        case 'on':
            stateCode = 9884;
            break;

        case 'california':
        case 'ca':
            stateCode = 9883;
            break;

        case 'washington':
        case 'ws':
            stateCode = 9882;
            break;

        case 'oregon':
        case 'or':
            stateCode = 9881;
            break;

        case 'arizona':
        case 'az':
            stateCode = 9880;
            break;

        case 'alaska':
        case 'ak':
            stateCode = 9879;
            break;

        case 'alabama':
        case 'al':
            stateCode = 9878;
            break;

        case 'arkansas':
        case 'ar':
            stateCode = 9877;
            break;

        case 'colorado':
        case 'co':
            stateCode = 9876;
            break;

        case 'connecticut':
        case 'ct':
            stateCode = 9875;
            break;

        case 'district Of columbia':
        case 'dc':
            stateCode = 9874;
            break;

        case 'delaware':
        case 'de':
            stateCode = 9873;
            break;

        case 'florida':
        case 'fl':
            stateCode = 9872;
            break;

        case 'georgia':
        case 'ga':
            stateCode = 9871;
            break;

        case 'hawaii':
        case 'hi':
            stateCode = 9870;
            break;

        case 'iowa':
        case 'ia':
            stateCode = 9869;
            break;

        case 'idaho':
        case 'id':
            stateCode = 9868;
            break;

        case 'illinois':
        case 'il':
            stateCode = 9867;
            break;

        case 'indiana':
        case 'in':
            stateCode = 9866;
            break;

        case 'kansas':
        case 'ks':
            stateCode = 9865;
            break;

        case 'kentucky':
        case 'ky':
            stateCode = 9864;
            break;

        case 'louisiana':
        case 'la':
            stateCode = 9863;
            break;

        case 'massachusetts':
        case 'ma':
            stateCode = 9862;
            break;

        case 'maryland':
        case 'md':
            stateCode = 9861;
            break;

        case 'maine':
        case 'me':
            stateCode = 9860;
            break;

        case 'michigan':
        case 'mi':
            stateCode = 9859;
            break;

        case 'minnesota':
        case 'mn':
            stateCode = 9858;
            break;

        case 'missouri':
        case 'mo':
            stateCode = 9857;
            break;

        case 'mississippi':
        case 'ms':
            stateCode = 9856;
            break;

        case 'montana':
        case 'mt':
            stateCode = 9855;
            break;

        case 'north carolina':
        case 'nc':
            stateCode = 9854;
            break;

        case 'north dakota':
        case 'nd':
            stateCode = 9853;
            break;

        case 'nebraska':
        case 'ne':
            stateCode = 9852;
            break;

        case 'new hampshire':
        case 'nh':
            stateCode = 9851;
            break;

        case 'new jersey':
        case 'nj':
            stateCode = 9850;
            break;

        case 'new mexico':
        case 'nm':
            stateCode = 9849;
            break;

        case 'new york':
        case 'ny':
            stateCode = 9848;
            break;

        case 'ohio':
        case 'oh':
            stateCode = 9847;
            break;

        case 'oklahoma':
        case 'ok':
            stateCode = 9846;
            break;

        case 'pennsylvania':
        case 'pa':
            stateCode = 9845;
            break;

        case 'Quebec':
        case 'qc':
            stateCode = 9844;
            break;

        case 'rhode island':
        case 'ri':
            stateCode = 9843;
            break;

        case 'south dakota':
        case 'sd':
            stateCode = 9842;
            break;

        case 'south carolina':
        case 'sc':
            stateCode = 9841;
            break;

        case 'tennessee':
        case 'tn':
            stateCode = 9840;
            break;

        case 'texas':
        case 'tx':
            stateCode = 9839;
            break;

        case 'utah':
        case 'ut':
            stateCode = 9838;
            break;

        case 'virginia':
        case 'va':
            stateCode = 9837;
            break;

        case 'vermont':
        case 'vt':
            stateCode = 9836;
            break;

        case 'west virginia':
        case 'wv':
            stateCode = 9835;
            break;

        case 'wyoming':
        case 'wy':
            stateCode = 9834;
            break;

        case 'manitoba':
        case 'mb':
            stateCode = 9833;
            break;

        case 'new brunswick':
        case 'nb':
            stateCode = 9832;
            break;

        case 'saskatchewan':
        case 'sk':
            stateCode = 9831;
            break;

        case 'prince edward island':
        case 'pe':
            stateCode = 9830;
            break;

        case 'nevada':
        case 'nv':
            stateCode = 9829;
            break;

        case 'wisconsin':
        case 'wi':
            stateCode = 9828;
            break;

        case 'newfoundland and labrador':
        case 'nl':
            stateCode = 9819;
            break;

        case 'nova scotia':
        case 'ns':
            stateCode = 9818;
            break;

        case 'Yukon':
        case 'yt':
            stateCode = 9817;
            break;

        case 'nunavut':
        case 'nu':
            stateCode = 9816;
            break;

        case 'northwest territories':
        case 'nt':
            stateCode = 9815;
            break;

        default:
            stateCode = 9886;
    };

    return stateCode;
};
